import React, { useState } from 'react'
import ModalDialog from '../../../components/layouts/ModalDialog'
import { Switch } from '@headlessui/react'
import ArrowRightLeft from '../../../components/elements/icons/ArrowRightLeft'
import TextField from '../../../components/elements/form/TextField'
import { userDetails } from '../../../utils'
import PasswordField from '../../../components/elements/form/PasswordField'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../../store/types'

const UserProfile = () => {
    const [passwordResetModal, setPasswordResetModal] = useState(false)
    const [twoFaModal, setTwoFaModal] = useState(false)
    const [twoFaActive, setTwoFaActive] = useState(false)
    const dispatch = useDispatch()

    const changePassword = () => {
        console.log('password changed :)')
    }

    const activate2Fa = () => {
        console.log('2FA activated :)')
    }

    const user = userDetails()

    const [userPayload, setUserPayload] = useState(user)

    const [validationErrors, setValidationErrors] = useState({})

        const validateForm = () => {
        let errors = {}
        if(!userPayload.name || userPayload.name === '') {
            errors.name = true
        }

        if(!userPayload.phone || userPayload.phone === '') {
            errors.phone = true
        }

        setValidationErrors(errors)

        return errors
    }



    const updateUser = async () => {
         try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            // dispatch(createTerm({...termPayload, session: academicSession._id}))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }
    
    return (
        <>
            <div className='w-1/2 mx-auto pb-[100px]'>
                <div className='w-full flex justify-between'>
                    <div>
                        <h3 className='text-lg font-medium'>Your user profile</h3>
                        <p className='text-sm'>You can see and edit your profile information below</p>
                    </div>
                    <div>
                    {/* <Link to={`new-role`} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                        <PlusIcon className='w-5 h-5' /> Create new role
                    </Link> */}

                    </div>
                </div>
                <div className='w-full flex flex-row gap-x-4 py-4'>
                    <div className="w-full">
                        {/* <label className="text-xs block mb-2">Name</label> */}
                        {/* <input type='text' value={userDetails.name} className='w-full px-4 py-2 rounded border border-primary border-opacity-30 bg-transparent text-xs focus:border-opacity-60 transition duration-200 focus:outline-none' /> */}
                        <TextField
                            inputLabel="Name" 
                            fieldId="name" 
                            inputType="text" 
                            requiredField={true}
                            preloadValue={user.name || ''}
                            hasError={validationErrors && validationErrors.name} 
                            returnFieldValue={(value)=>{setUserPayload({...userPayload, name: value})}}
                        />
                    </div>
                </div>
                {/* <div className='w-full flex flex-row gap-x-4 py-4'> */}
                    <div className="w-full py-4">
                        <TextField
                            inputLabel="Email" 
                            fieldId="email" 
                            inputType="text" 
                            requiredField={true}
                            preloadValue={user.email || ''}
                            hasError={validationErrors && validationErrors.email} 
                            returnFieldValue={(value)=>{setUserPayload({...userPayload, email: value})}}
                            disabled={true}
                        />
                    </div>
                    <div className="w-full py-4">
                        <TextField
                            inputLabel="Phone number" 
                            fieldId="phone" 
                            inputType="text" 
                            requiredField={true}
                            preloadValue={user.phone || ''}
                            hasError={validationErrors && validationErrors.phone} 
                            returnFieldValue={(value)=>{setUserPayload({...userPayload, phone: value})}}
                        />
                    </div>
                {/* </div> */}
                <div className='my-5'>
                    <button onClick={()=>{updateUser()}} className="text-right rounded bg-primary px-5 py-4 text-xs text-white transition duration-200 hover:bg-opacity-50">Update Profile</button>
                </div>

                <div className='w-full flex justify-between mt-[40px] pt-[40px] border-t border-gray-400'>
                    <div>
                        <h3 className='text-lg font-medium'>Security Settings</h3>
                        <p className='text-sm'>Use the settings below to secure your account</p>
                    </div>
                    <div>
                    {/* <Link to={`new-role`} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                        <PlusIcon className='w-5 h-5' /> Create new role
                    </Link> */}

                    </div>
                </div>
                
                <div className='grid grid-cols-2 gap-8 my-8'>
                    <div className="bg-gray-100 p-4">
                        <div>
                            <p className="text-primary font-space-grotesk font-medium">Account Password</p>
                            <p className="text-sm mt-1 text-opacity-40">Manage your account password</p>

                            <div className="w-full flex items-center justify-between mt-3 py-3 border-t">
                                <button onClick={()=>{setPasswordResetModal(true)}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>Change Password <ArrowRightLeft className={`w-4 h-4`} /></button> 

                                {/* <button onClick={()=>{deleteDesignation()}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                    <TrashIcon className={`w-5 h-5`} />
                                </button> */}
                            </div>
                        </div>

                    </div>

                    <div className="bg-white p-4">
                        <div>
                            <p className="text-primary font-space-grotesk font-medium">Two-Factor Authentication</p>
                            <p className="text-sm mt-1 text-opacity-40">Manage 2FA settings for your account</p>

                            <div className="w-full flex items-center justify-between mt-3 py-3 border-t">
                                <button onClick={()=>{setTwoFaModal(true)}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>Activate 2FA <ArrowRightLeft className={`w-4 h-4`} /></button> 

                                {/* <button onClick={()=>{deleteDesignation()}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                    <TrashIcon className={`w-5 h-5`} />
                                </button> */}
                            </div>
                        </div>

                    </div>
                </div>

                <div className='w-full mt-[40px] pt-[40px] border-t border-gray-400'>
                    <div>
                        <h3 className='text-lg font-medium'>Assigned Roles</h3>
                        <p className='text-sm'>Below are the roles you've been assigned. These roles determine what actions you are allowed to perform on this system</p>
                    </div>
                    <div className='w-full mt-[20px]'>
                        {user?.adminRoles?.map((role, roleIndex) => (
                            <div key={roleIndex} className='p-[20px] bg-gray-100 bg-opacity-50 rounded-[8px] my-[10px]'>
                                <h3 className='font-space-grotesk text-gray-800 font-[550]'>{role.name}</h3>
                                <p className='text-sm text-gray-500'>{role.description}</p>
                                <span className='p-[5px] text-xs bg-gray-200 bg-opacity-75 inline-block mt-[15px]'>{role.permissions?.length} permission(s)</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <ModalDialog 
                shown={passwordResetModal} 
                closeFunction={()=>{setPasswordResetModal(false)}} 
                actionFunction={()=>{changePassword()}} 
                actionFunctionLabel='Change Password' 
                dialogTitle='Change Your Account Password'
                maxWidthClass='max-w-md'
            >
                <div>
                    <PasswordField
                        inputLabel="Current password" 
                        fieldId="current-password" 
                        inputType="text" 
                        requiredField={true}
                        preloadValue={''}
                        inputPlaceholder={'Your current account password'}
                        hasError={validationErrors && validationErrors.email} 
                        returnFieldValue={(value)=>{}}
                        disabled={true}
                    />
                </div>
                <div className='mt-5'>
                    <PasswordField
                        inputLabel="New password" 
                        fieldId="new-password" 
                        inputType="text" 
                        requiredField={true}
                        preloadValue={''}
                        inputPlaceholder={`Choose a strong password`}
                        hasError={validationErrors && validationErrors.email} 
                        returnFieldValue={(value)=>{}}
                        disabled={true}
                    />
                </div>
                <div className='mt-5'>
                    <PasswordField
                        inputLabel="Confirm new password" 
                        fieldId="confirm-new-password" 
                        inputType="text" 
                        requiredField={true}
                        preloadValue={''}
                        inputPlaceholder={`Re-type your new password`}
                        hasError={validationErrors && validationErrors.email} 
                        returnFieldValue={(value)=>{}}
                        disabled={true}
                    />
                </div>
            </ModalDialog>

            <ModalDialog 
                shown={twoFaModal} 
                closeFunction={()=>{setTwoFaModal(false)}} 
                actionFunction={()=>{activate2Fa()}} 
                actionFunctionLabel='Activate two-factor authentication' 
                dialogTitle='Activate/Deactivate Two-Factor Authentication'
                maxWidthClass='max-w-md'
            >
                <div className="w-full flex justify-between gap-x-4 py-4 border-b border-secondary border-opacity-50">
                    <div className='w-4/5'>
                        <p className="text-sm font-sofia-pro">Activate Two-factor Authentication</p>
                        <p className='text-gray-500 text-xs mt-2'>
                            Two-factor authentication further protects access your account by sending an OTP to your registered phone number and email address everytime you make an attempt to log in to your account
                        </p>
                    </div>
                    <Switch
                        checked={twoFaActive}
                        onChange={setTwoFaActive}
                        className={`${
                            twoFaActive ? 'bg-accent' : 'bg-gray-400'
                        } relative inline-flex items-center h-5 rounded-full w-10`}
                        >
                        <span className="sr-only">Activate 2FA</span>
                        <span
                            className={`transform transition ease-in-out duration-200 ${
                                twoFaActive ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                            } inline-block w-3 h-3 transform rounded-full`}
                        />
                    </Switch>
                </div>
            </ModalDialog>
        </>
    )
}

export default UserProfile
